import React from "react";
import { formatCount } from "../../utils/textLimits";

/**
 * "1,950 / 2,000 characters" under a text box with a character limit, so the limit is visible before it is
 * hit. Multi-line boxes show it always; single-line boxes from 80% of the limit. Over the limit it turns red
 * and says by how much (the form then refuses to submit with a message naming the field).
 */
export default function CharLimitHint({ value, max, alwaysShow = false, id }) {
    const length = (value || "").length;
    if (!alwaysShow && length < max * 0.8) return null;
    const over = length - max;
    return (
        <div id={id} data-testid="char-limit-hint" aria-live="polite"
            className={`text-[11px] mt-0.5 ${over > 0 ? "text-red-600 font-medium" : "text-gray-400"}`}>
            {formatCount(length)} / {formatCount(max)} characters{over > 0 ? ` — ${formatCount(over)} over the limit` : ""}
        </div>
    );
}
